// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import { ReactComponent as XIcon } from "assets/cross.svg";

// API
import { useCreateSofiaPurchase } from "api/sofia-magic-studio";

const ModalTambahKreditDetail = ({
  selectedPackage,
  onBack,
  onClose,
  isOpen,
  onSuccess,
  ...props
}) => {
  const { mutate: createPurchase, isPending } = useCreateSofiaPurchase();

  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  const handlePayment = () => {
    if (!selectedPackage) return;

    createPurchase(
      { sofia_package_id: selectedPackage.id },
      {
        onSuccess: (response) => {
          const paymentUrl = response?.data?.data?.payment_url;
          if (paymentUrl) {
            window.open(paymentUrl, "_blank");
            onClose();
          }
          onSuccess();
        },
        onError: (error) => {
          console.error("Payment error:", error);
        },
      },
    );
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[520px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-between px-4 py-2">
          <p className="text-[17px] font-inter-semibold">
            Lanjutkan ke pembayaran?
          </p>
          <XIcon onClick={onClose} />
        </div>

        <div className="px-6 py-2 gap-4">
          <div className="grid grid-cols-3 items-center border-b border-solid border-[#D8D8D9] mb-1 pb-1">
            <p className="text-[13px] font-inter text-[#808285]">Paket</p>
            <p className="text-[13px] font-inter text-[#808285] text-right">
              Kredit
            </p>
            <p className="text-[13px] font-inter text-[#808285] text-right">
              Harga
            </p>
          </div>
          <div className="grid grid-cols-3 items-center border-b border-dashed border-[#D8D8D9] pb-4 mb-1">
            <p className="text-[13px] font-inter-semibold text-[#252526]">
              {selectedPackage?.name || "-"}
            </p>
            <p className="text-[13px] font-inter text-[#252526] text-right">
              {selectedPackage?.credits?.toLocaleString("id-ID") || "0"}
            </p>
            <p className="text-[13px] font-inter text-[#252526] text-right">
              {selectedPackage?.price
                ? formatPrice(selectedPackage.price)
                : "Rp0"}
            </p>
          </div>
          <div className="flex gap-2 items-center justify-between">
            <p className="text-[13px] font-inter text-[#252526]">
              Total yang harus dibayar
            </p>
            <p className="text-[13px] font-inter-semibold text-[#252526]">
              {selectedPackage?.price
                ? formatPrice(selectedPackage.price)
                : "Rp0"}
            </p>
          </div>
        </div>
        <div className="flex items-center justify-between px-4 py-2 border-t border-solid border-[#D8D8D9]">
          <p className="text-[11px] font-inter italic text-[#808285]">
            <span className="text-[#F04438]">*</span>Kredit dapat dibagikan
            kepada marketing.
          </p>

          <div className="flex items-center gap-2">
            <Button
              type="secondary"
              size="md"
              text="Kembali"
              onClick={onBack}
            />
            <Button
              type="primary"
              size="md"
              text={isPending ? "Memproses..." : "Lanjutkan Pembayaran"}
              onClick={handlePayment}
              disabled={isPending || !selectedPackage}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalTambahKreditDetail isOpen={isOpen} {...props} />;
};

export default Wrapper;
